var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "smartphone",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.82,
    height: 18,
    viewBox: "0 0 10.82 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_76004",
    "data-name": "Group 76004"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139577",
    "data-name": "Path 139577",
    d: "M98.426,0h-6.32a2.244,2.244,0,0,0-2.25,2.25v13.5A2.257,2.257,0,0,0,92.106,18h6.32a2.244,2.244,0,0,0,2.25-2.25V2.25A2.244,2.244,0,0,0,98.426,0Zm-3.15,16.548A1.023,1.023,0,1,1,96.3,15.525,1.013,1.013,0,0,1,95.276,16.548Zm4.377-3.13H90.879V3.007h8.775Z",
    transform: "translate(-89.856)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.b1762ff646b0d6d587f5ebf17a1f5dd8.svg";
export { ForwardRef as ReactComponent };